import { CREATE_USER_GROUP, FETCH_USER_GROUP, GET_USER_GROUP, DELETE_USER_GROUP, UPDATE_USER_GROUP } from 'actions/userGroup';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  userGroups: [],
  userGroupDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const userGroupReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_USER_GROUP.REQUEST:
    case CREATE_USER_GROUP.REQUEST:
    case GET_USER_GROUP.REQUEST:
    case DELETE_USER_GROUP.REQUEST: {
      return { ...state, isLoading: true, userGroupDetail: {} };
    }

    case UPDATE_USER_GROUP.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_USER_GROUP.SUCCESS: {
      if (payload.page === 1) {
        return {
          ...state,
          isLoading: false,
          userGroups: payload.results,
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          userGroups: _.concat(state.userGroups, payload.results),
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      }
    }

    case GET_USER_GROUP.SUCCESS: {
      return {
        ...state,
        userGroupDetail: payload,
        isLoading: false,
      };
    }

    case CREATE_USER_GROUP.SUCCESS: {
      toast.success(' User group added successfully');
      return {
        ...state,
        userGroups: _.concat(state.userGroups, payload),
        isLoading: false,
      };
    }

    case UPDATE_USER_GROUP.SUCCESS: {
      toast.success(' User group updated successfully');
      return {
        ...state,
        isLoading: false,
        userGroups: state.userGroups.map((data) => (data.id === payload.id ? payload : data)),
      };
    }

    case DELETE_USER_GROUP.SUCCESS: {
      toast.success(' User group deleted successfully');
      return {
        ...state,
        isLoading: false,
        userGroups: state.userGroups.filter((data) => data.id !== payload),
      };
    }

    case FETCH_USER_GROUP.FAIL:
    case CREATE_USER_GROUP.FAIL:
    case GET_USER_GROUP.FAIL:
    case DELETE_USER_GROUP.FAIL:
    case UPDATE_USER_GROUP.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default userGroupReducer;
